const log = {
    invalid_type: 'Type de journalisation invalide.',
    invalid_time_window: '`end_time` doit être postérieur à `start_time`.',
};
export default Object.freeze(log);
